module.exports = {
      id: "share-mail-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#share-mail",
      toString: function () {
        return this.url;
      }
    }